import Container from 'react-bootstrap/Container';
import NavBar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { CurrentUser } from '../contexts/CurrentUser';
import { useContext } from 'react';

import { ROUTES } from '../utils/navigation';

function Navigation() {
    const { isLoggedIn } = useContext(CurrentUser);

    if (!isLoggedIn) {
        return ''
    }
    return <>
        <NavBar className='navigation-bar'>
            <Container>
                <div className="brand-headline">
                    <NavBar.Brand href={ROUTES.HOME}>
                        <img
                            src="/assets/logo.svg"
                            alt="NORM 2023 Logo"
                            width='120px'
                            preserveAspectRatio="xMidYMid meet"
                        />
                    </NavBar.Brand>
                    <h1 className='main-title'>Forum Archives</h1>
                </div>
                <Nav className='links'>
                    <Nav.Link className='search-archive-link' href={ROUTES.SEARCH}>Search Archives</Nav.Link>
                    <Nav.Link className='list-forums-link'href={ROUTES.LIST_FORUMS}>List Forums</Nav.Link>
                </Nav>
            </Container>
        </NavBar>
        <div className='navigation-links'>
            <Nav.Link className='search-archive-link' href={ROUTES.SEARCH}>Search Archives</Nav.Link>
            <Nav.Link className='list-forums-link'href={ROUTES.LIST_FORUMS}>List Forums</Nav.Link>
        </div>
    </>
}

export default Navigation;